module.exports = __webpack_public_path__ + "img/120.214e7040.png";